import { AbsoluteCenter, Box, Heading, Stack, } from "@chakra-ui/react";
import { useLoginFormStore, } from "../../store/loginFormStore.ts";
import { PassportForm, } from "../../components/features/LoginPage/PassportForm";
import { EPhoneFormState, } from "../../store/slices/phoneFormSliceCreator.ts";
import { redirect, } from "react-router-dom";

export function PassportPage() {
  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={9} minW="300px">
          <div>
            <Heading fontSize={20} mb={2} textAlign="center">Подтверждение личности</Heading>
          </div>
          <PassportForm />
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

PassportPage.loader = () => {
  const formState = useLoginFormStore.getState();

  if (formState.phoneFormState !== EPhoneFormState.submitted) {
    return redirect("/login",);
  }
  return null;
};
